import React from "react";
import PracticsQuestionTopics from "../../../topics/PracticsQuestionTopics";


function ChapterWisePYQChemTopics() {
  return (
    <>

      <PracticsQuestionTopics subject="chemistry" type="chapterwisepyq" />

    </>
  );
}

export default ChapterWisePYQChemTopics;